import { render } from "./EventsTable.vue?vue&type=template&id=74850d60"
import script from "./EventsTable.vue?vue&type=script&lang=js"
export * from "./EventsTable.vue?vue&type=script&lang=js"

import "./EventsTable.vue?vue&type=style&index=0&id=74850d60&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__